export default {
    SET_RENDERED_AD_IDS(state, adId) {
        state.renderedAdIds.push(adId);
    },
};
